<template>
  <div :class="{ active: activeSlider, right: side === 'right', left: side === 'left' }" class="all-slider">
    <div class="blur-slider-form" @click="handleActiveChange"></div>
    <div class="slider-form">
      <div class="slider-header">
        <h4>
          {{ title }}
        </h4>
        <i class="mdi mdi-close mdi-24px" @click="handleActiveChange"> </i>
      </div>
      <div class="slider-notification mt-1">
        <slot name="notification" />
      </div>
      <div class="slider-content">
        <slot />
      </div>
      <div v-if="footer" class="slider-footer">
        <h-b-action :positive="false" color="primary" text="Annuler" @click.native="emitCancelFunction"></h-b-action>
        <h-b-action
          v-if="deleteButton && loaded"
          :positive="true"
          color="danger"
          text="Supprimer"
          @click.native="emitDeleteFunction"
        ></h-b-action>
        <h-b-action
          v-if="loaded"
          :positive="true"
          color="primary"
          text="Valider"
          @click.native="emitSubmitFunction"
        ></h-b-action>
        <div v-else class="d-flex justify-content-center align-items-center">
          <b-spinner variant="primary" style="width: 1.6rem; height: 1.6rem"></b-spinner>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HBAction from '../buttons/action'

export default {
  name: 'slider',

  components: {
    HBAction,
  },

  props: {
    side: {
      type: String,
      default: 'right',
    },
    value: Boolean,
    title: {
      type: String,
      required: true,
    },
    loaded: {
      type: Boolean,
      default: true,
    },
    footer: {
      type: Boolean,
      default: true,
    },
    deleteButton: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      activeSlider: this.value,
    }
  },

  watch: {
    value() {
      this.activeSlider = this.value
    },
  },

  mounted() {
    window.addEventListener('keyup', this.keyHandler)
  },

  methods: {
    keyHandler(event) {
      if (this.activeSlider) {
        switch (event.key) {
          case 'Enter':
            this.emitSubmitFunction()
            break
          case 'Escape':
            this.emitCancelFunction()
            break
          default:
        }
      }
    },

    emitCancelFunction() {
      this.$emit('clickCancel')
    },

    emitSubmitFunction() {
      this.$emit('clickSubmit')
    },

    emitDeleteFunction() {
      this.$emit('clickDelete')
    },

    handleActiveChange() {
      this.activeSlider = !this.activeSlider
      this.$emit('input', this.activeSlider)
    },
  },
}
</script>

<style scoped></style>
